import React from "react";
import {withTranslation} from "react-i18next";
import styles from "./InformazioniFocolaio.module.css";
import Autocomplete from "../../../components/autocomplete/Autocomplete";
import Input from "../../../components/textbox/Input"
import Calendar from "../../../components/calendar/Calendar"
import history from "../../../utils/History"
import Modale from "../../../components/modale/Modale"
import OggettiUtili from "../../../utils/OggettiUtili"
import Table from "../../../components/table/Table"
import Button from "../../../components/button/Button"
import Utils from "../../../utils/Utils"
import FocolaiServices from "../../../services/FocolaiServices";
import SegnalazioniServices from "../../../services/SegnalazioniServices";
import RadioButton from "../../../components/radiobutton/RadioButton";
import Spinner from "../../../components/spinner/Spinner";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import TableAllegatoFocolaio from "./caricaAllegatoFocolaio/TableAllegatoFocolaio";
import $ from "jquery";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import MalattieService from "../../../services/MalattieService";
import toasterConfig from "../../../config/toasterConfig";
import {labelConfig} from "../../../config/labelConfig";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";
import Ruoli from "../../../utils/Ruoli";
import globals from "../../../config/appconfig";
import { format } from "date-fns";


class InformazioniFocolaio extends React.Component {

    state = {
        initialRows: [],
        malattie: JSON.parse(sessionStorage.getItem("malattieFocolai")),
        regioni: OggettiUtili.Regioni,
        province: JSON.parse(sessionStorage.getItem("province")),
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comunita: OggettiUtili.Collettivita,
        agenti: OggettiUtili.Agenti,
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        provinciePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice")),
        listaVeicoli: [],
        sections: {
            idFocolaio: "",
            malattia: "",
            ulss: "",
            dataCompilazione:"",
            regione: "",
            provincia: "",
            comune: "",
            indirizzo: "",
            recapito: "",
            numeroCasi: "",
            comunita: "",
            comunitaAltro: "",
            numeroPersoneRischio: "",
            originePresunta: "",
            dataInizio: "",
            durata: "",
            agente: "",
            veicolo: "",
            agenteId: 0,
            veicoloId: 0,
            etichetta: "",
            note: "",
            migrazione: false,
            dataMigrazione: null,
            altreInformazioniMigrazione: "",
            stato: ""
        },
        segnalazioniAssociate: [],
        segnalazioniDaAssociare: [],
        segnalazioniDaEliminare: [],
        casoZero: null,
        casoZeroOld: null,
        casoZeroIniziale:null,
        isModifica: false,
        loading: false,
        totalElements: "",
        disabledAssociazione: true,
        getModifica: false,
        page: 0,
        totalPages: 0,
        size: 10,
        idSessioneFocolaio: "",
        file: null,
        fileDaCaricare: null,
        fileCaricato: null,
        fileDaEliminare: null
    };

    cols = [
        {key: "checked", name: "", tipo: "checkbox", deselect: true},
        {key: "idSegnalazione", name: "Tables.InformazioniFocolaio.id", sortDirection: "none"},
        {key: "malattia", name: "Tables.InformazioniFocolaio.malattia", sortDirection: "none"},
        {key: "paziente", name: "Tables.InformazioniFocolaio.paziente", sortDirection: "none"},
        {
            key: "ulssAppartenenza",
            name: "Tables.InformazioniFocolaio.ulssApp",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataSegnalazione", name: "Tables.InformazioniFocolaio.data", sortDirection: "none", tipo: "data"},
        {
            key: "statoSegnalazione",
            name: "Tables.InformazioniFocolaio.stato",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },
        {key: "casoZero", name: "Tables.InformazioniFocolaio.caso_zero", tipo: "checkbox", isRadio: true},
    ]


    constructor(props) {
        super(props);

        this.state.sections.regione = OggettiUtili.Regioni["050"];
        this.setNavLabel(0)

        this.state.idSessioneFocolaio = "" + Math.floor(Math.random() * (999999999))

        if (this.props.location.infoState) {
            this.state = this.props.location.infoState;

            if (this.props.location.segnalazioniDaAssociare)
                this.state.segnalazioniDaAssociare = this.props.location.segnalazioniDaAssociare;
        }

        if (this.props.location.malattia) {
            this.state.sections.malattia = this.props.location.malattia;
        }

        if (this.props.location.etichetta) {
            this.state.sections.etichetta = this.props.location.etichetta;
        }

        this.riceviValore = this.riceviValore.bind(this);
        this.selezionaAgenteRadio = this.selezionaAgenteRadio.bind(this);
        this.selezionaVeicoloRadio = this.selezionaVeicoloRadio.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
        this.onSelectCasoZero = this.onSelectCasoZero.bind(this);
        this.removeSegnalazione = this.removeSegnalazione.bind(this);
        this.home = this.home.bind(this);
        this.associaSegnalazione = this.associaSegnalazione.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        this.onSubmit = this.onSubmit.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.associaFocolaioASegnalazione = this.associaFocolaioASegnalazione.bind(this)
        this.setStateGenerico = this.setStateGenerico.bind(this);
        this.setNavLabel = this.setNavLabel.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.disableCasoZero = this.disableCasoZero.bind(this);
        this.caricaPdf = this.caricaPdf.bind(this);
        this.setStatePadre = this.setStatePadre.bind(this);
        this.toBase64 = this.toBase64.bind(this);
        this.showSpinner = this.showSpinner.bind(this);
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this);

    }

    disableCalendar() {
        if (this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice) {
            $(document).ready(function () {
                $("#dataInizio").datepicker('disable');
                $("#dataCompilazione").datepicker('disable');
            })
        } else if (this.state.sections.migrazione) {
            $(document).ready(function () {
                $("#dataInizio").datepicker('enable');
                $("#dataCompilazione").datepicker('enable');
            })
        } else {
            $(document).ready(function () {
                $("#dataInizio").datepicker('enable');
                $("#dataCompilazione").datepicker('disable');
            })
        }
    }

    componentDidMount() {

        ToasterSingleton.instance().sottoscrizione(this)
        this.disableCalendar()

        if (this.props.location.idSegnalazioneMonckey) {
            this.state.segnalazioniDaAssociare.push(this.props.location.idSegnalazioneMonckey)
            let segnalazioniSelez = [this.props.location.idSegnalazioneMonckey]
            let jsonRequest = {
                segnalazioniAssociate: segnalazioniSelez
            };

            let dataInizio = Utils.transformDateForBackend(this.state.sections.dataInizio);
            let dataCompilazione = Utils.transformDateForBackend(this.state.sections.dataCompilazione);
            let jsonInsert = JSON.parse(JSON.stringify(this.state.sections));
            jsonInsert["malattia"] = this.state.sections.malattia;
            jsonInsert["ulss"] = SessioneUtente.getInstance().ulss;
            jsonInsert["regione"] = this.state.sections.regione.codice;
            jsonInsert["provincia"] = this.state.sections.provincia.codice;
            jsonInsert["comune"] = this.state.sections.comune.codice;
            jsonInsert["comunita"] = this.state.sections.comunita.codice;
            jsonInsert["dataInizioEpidemia"] = dataInizio;
            jsonInsert["dataCompilazione"] = dataCompilazione;
            jsonInsert["statoAgente"] = this.state.sections.agenteId;
            jsonInsert["statoVeicolo"] = this.state.sections.veicoloId;
            jsonInsert["nomeAgente"] = this.state.sections.agente.codice;
            jsonInsert["nomeVeicolo"] = this.state.sections.veicolo;

            jsonInsert["flagBozza"] = true;

            FocolaiServices.postInserimentoFocolaio(Utils.removeEmptyValueFromObject(jsonInsert))
                .then((data) => {

                    if (data && data.status === 200) {
                        if (data.data && data.data.idFocolaio) {
                            console.log("Focolaio creato con successo")
                            let idFocolaio = data.data.idFocolaio
                            let section = this.state.sections;
                            section.idFocolaio = idFocolaio;
                            this.setState({sections: section})
                            SegnalazioniServices.putAssociaFocolaio(idFocolaio, jsonRequest, this.state.idSessioneFocolaio)
                                .then((data) => {
                                    console.log("Segnalazione associata con successo")
                                    let params = {
                                        ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                                        || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                                            ? SessioneUtente.getInstance().ulss : null,
                                        focolaio: idFocolaio,
                                        idSessioneFocolaio: this.state.idSessioneFocolaio,
                                        page: this.state.page,
                                        size: this.state.size
                                    };

                                    this.callGetSegnalazioniAssociate(Utils.removeEmptyValueFromObject(params)).then((data) => {
                                        MalattieService.getInfoMalattia(this.state.sections.malattia).then((data) => {
                                            this.setState({listaVeicoli: data.data.veicoli, loading: false})
                                        }).catch((reason) => {
                                            console.log("errore chiamata InfoMalattia")
                                            this.setState({loading: false})
                                        });
                                    }).catch((reason) => {
                                        console.log("errore chiamata GetSintesiSegnalazioni")
                                        this.setState({loading: false})
                                    });
                                }).catch(() => {
                                console.log("[ERR] Error put associa focolaio");
                            });
                        }
                    }
                }).catch(err => {
                console.log("[ERR] Error while save");
                console.log(err);
            });
        }

        if (this.props.location.malattia) {
            this.setState({loading: true})
            MalattieService.getInfoMalattia(this.props.location.malattia).then((data) => {
                this.setState({listaVeicoli: data.data.veicoli, loading: false})
            }).catch((reason) => {
                console.log("errore chiamata InfoMalattia")
                this.setState({loading: false})
            });
        } else if (this.props.location.infoState && this.props.location.infoState.sections.idFocolaio) {
            let params = {
                ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                    || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                    ? SessioneUtente.getInstance().ulss : null,
                focolaio: this.state.sections.idFocolaio,
                idSessioneFocolaio: this.state.idSessioneFocolaio,
                page: this.state.page,
                size: this.state.size
            };

            this.callGetSegnalazioniAssociate(Utils.removeEmptyValueFromObject(params)).then((data) => {
                MalattieService.getInfoMalattia(this.state.sections.malattia).then((data) => {
                    this.setState({listaVeicoli: data.data.veicoli, loading: false})
                }).catch((reason) => {
                    console.log("errore chiamata InfoMalattia")
                    this.setState({loading: false})
                });
            }).catch((reason) => {
                console.log("errore chiamata GetSintesiSegnalazioni")
                this.setState({loading: false})
            });
        } else if (this.props.location.idFocolaio) {
            this.setNavLabel(1)

            this.setState({loading: true})

            FocolaiServices.getFocolaio(this.props.location.idFocolaio).then(data => {

                let res = FocolaiServices.mapGetFocolai(data);
                let section = this.state.sections;
                let agenteCheck = 0;
                let veicoloCheck = 0;
                let file = data.data.focolaioPdfDTO ? data.data.focolaioPdfDTO : null;
                if (file)
                    file.isNewFile = true;

                section.idFocolaio = data.data.idFocolaio;
                section.ulss = data.data.ulss;
                section.malattia = res.malattia.codice;
                section.regione = res.regione;
                section.provincia = res.provincia;
                section.comune = res.comune;
                section.comunita = data.data.comunita;
                section.comunitaAltro = data.data.comunitaAltro ? data.data.comunitaAltro : ""
                section.agente = data.data.nomeAgente;
                section.numeroPersoneRischio = data.data.numeroPersoneRischio;
                section.indirizzo = data.data.indirizzo;
                section.recapito = data.data.recapito;
                section.dataInizio = data.data.dataInizioEpidemia ? Utils.formatDateISO(data.data.dataInizioEpidemia, "/") : ""
                section.dataCompilazione = data.data.dataCompilazione ? Utils.formatDateISO(data.data.dataCompilazione, "/") : ""
                section.numeroCasi = data.data.numeroCasi;
                section.originePresunta = data.data.originePresunta;

                if (data.data.agenteIdentificato == 1) agenteCheck = 1;
                else if (data.data.agenteSospetto == 2) agenteCheck = 2;
                else agenteCheck = 0;

                if (data.data.veicoloIdentificato == 1) veicoloCheck = 1;
                else if (data.data.veicoloSospetto == 2) veicoloCheck = 2;
                else veicoloCheck = 0;

                section.agenteId = agenteCheck;
                section.veicoloId = veicoloCheck;

                section.veicolo = data.data.nomeVeicolo;
                section.etichetta = data.data.etichetta;
                section.durata = data.data.durata;
                section.note = data.data.note;
                section.migrazione = data.data.migrazione;
                section.dataMigrazione = data.data.dataMigrazione ? Utils.formatDateISO(data.data.dataMigrazione, "/") : ""
                section.altreInformazioniMigrazione = data.data.altreInformazioniMigrazione;
                section.stato = data.data.stato;

                let params = {
                    ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                        || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                        ? SessioneUtente.getInstance().ulss : null,
                    focolaio: section.idFocolaio,
                    idSessioneFocolaio: section.idSessioneFocolaio
                };


                this.callGetSegnalazioniAssociate(Utils.removeEmptyValueFromObject(params)).then((data) => {
                    MalattieService.getInfoMalattia(section.malattia).then((data) => {
                        this.setState({sections: section, listaVeicoli: data.data.veicoli, loading: false, fileCaricato: file})
                        $('.selectpicker').selectpicker("refresh");
                    }).catch((reason) => {
                        console.log("errore chiamata InfoMalattia")
                        this.setState({loading: false, sections: section, fileCaricato: file})
                        $('.selectpicker').selectpicker("refresh");
                    });
                }).catch(() => {
                    console.log("errore chiamata GetSintesiSegnalazioni")
                    this.setState({loading: false, sections: section, fileCaricato: file})
                    $('.selectpicker').selectpicker("refresh");
                });


            }).catch(err => {
                this.setState({loading: false});
            });

        }

        if(!this.state.sections.migrazione){
            let sections = this.state.sections
            sections.dataCompilazione = Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp())
            this.setState({sections:sections})
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disableCalendar()
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
        ToasterSingleton.instance().pulisci()
        this.props.navLabel("")
    }

    setNavLabel(n) {
        let object = {
            label: labelConfig.InformazioniFocolaio[n],
            setStatePadre: this.setStateGenerico
        }
        this.props.navLabel({navLabel: object})
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    showSpinner (value) {
        this.setState ({loading: value});
    }

    aggiungiToaster(text, textList) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList
        })
    }

    controlloDatiToaster(associa){
        let text = [];
        let infoFocolaio = this.state

        if(!infoFocolaio.sections.malattia){
            text.push("Campo \"Malattia\" mancante")
        }
        if(!associa){
            if((!infoFocolaio.sections.regione || (infoFocolaio.sections.regione && !infoFocolaio.sections.regione.codice))) text.push("Campo \"Regione\" mancante")
            if((!infoFocolaio.sections.provincia || (infoFocolaio.sections.provincia && !infoFocolaio.sections.provincia.codice))) text.push("Campo \"Provincia\" mancante")
            if((!infoFocolaio.sections.comune || (infoFocolaio.sections.comune && !infoFocolaio.sections.comune.codice))) text.push("Campo \"Comune\" mancante")
            if((!infoFocolaio.sections.comunita || (infoFocolaio.sections.comunita && !infoFocolaio.sections.comunita))) text.push("Campo \"Comunità\" mancante")
            if((!infoFocolaio.sections.comunitaAltro && infoFocolaio.sections.comunita && infoFocolaio.sections.comunita === "3")) text.push("Campo \"Comunità - Altro\" mancante")
            if(!infoFocolaio.sections.etichetta) text.push("Campo \"Etichetta - Nome focolaio\" mancante")
            if((!infoFocolaio.sections.numeroCasi && infoFocolaio.sections.numeroCasi !== 0)) text.push("Campo \"Numero di casi\" mancante")
            if((!infoFocolaio.sections.dataCompilazione || infoFocolaio.sections.dataCompilazione && Utils.isDateInValid(Utils.transformDateForBackend(infoFocolaio.sections.dataCompilazione), "-"))) text.push("Campo \"Data compilazione\" mancante")

        }

        if(text.length === 0 && !associa) this.sendRequest()
        else if(text.length === 0 && associa) this.associaSegnalazione()
        else return (this.aggiungiToaster(text, true))

    }

    changePageTable(sort, direction, page, size) {

        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss : null,
            focolaio: this.state.sections.idFocolaio,
            idSessioneFocolaio: this.state.idSessioneFocolaio
        };

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }

        params.page = page;

        if (sort !== null) {
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        this.callGetSegnalazioniAssociate(Utils.removeEmptyValueFromObject(params));
    }

    changePaginationTable(sort, direction, page, size) {
        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione
                || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione
                ? SessioneUtente.getInstance().ulss : null,
            focolaio: this.state.sections.idFocolaio,
            idSessioneFocolaio: this.state.idSessioneFocolaio
        };

        if (sort !== null) {
            params.sort = sort
        }

        if (direction !== null) {
            params.order = direction
        }

        params.page = page;
        params.size = size;

        this.callGetSegnalazioniAssociate(Utils.removeEmptyValueFromObject(params));
    }

    callGetSegnalazioniAssociate(params) {
        return SegnalazioniServices.getSegnalazioni(params).then((data) => {
            let res = SegnalazioniServices.mapGetSegnalazioni(data);
            let newState = {}
            for (let i in res) {

                if (this.state.casoZero) {

                    if (res[i].idSegnalazione !== this.state.casoZero) {
                        res[i].casoZero = false
                    } else {
                        res[i].casoZero = true
                    }
                }

                let z = Utils.checkObjectInArrayByObjectId(this.state.segnalazioniDaEliminare, "idSegnalazione", res[i].idSegnalazione);
                if (z < 0) {
                    res[i]["checked"] = true;
                } else {
                    res[i]["checked"] = false;
                }
                if(res[i].casoZero) {
                    newState["casoZeroIniziale"] = res[i].idSegnalazione;
                    newState["casoZero"] = res[i].idSegnalazione;
                }
            }

            newState ["segnalazioniAssociate"]=res; 
            newState ["totalElements"]= data.data.totalElements;
            newState ["totalPages"]= data.data.totalPages;
            newState ["loading"]= false;
            

            if (params.size && params.size !== this.state.size) {
                newState["size"] = params.size
            }
            if ((params.page || params.page === 0) && params.page !== this.state.page) {
                newState["page"] = params.page
            }

            this.setState(newState);

        }).catch((reason) => {
            console.log("errore chiamata GetSintesiSegnalazioni")
            this.setState({loading: false})
        });

    }

    associaFocolaioASegnalazione(idFocolaio, jsonFocolaio) {
        SegnalazioniServices.putAssociaFocolaio(idFocolaio, jsonFocolaio)
            .then((data) => {
                if (data) {
                    if (data.status === 200) {
                        let path = "/ricercaFocolai";
                        history.push({
                            pathname: path
                        });
                    }
                }
            }).catch(err => {
            console.log("[ERR] Error put associa focolaio");
            console.log(err);
        });
    }


    sendRequest() {

        if ((this.state.totalElements - this.state.segnalazioniDaEliminare.length) > parseInt(this.state.sections.numeroCasi)) {
            return (this.aggiungiToaster(["Messages.ERR_01_07_0B_0B"]))
        }

        if (this.state.sections.dataInizio && Utils.validateDate(this.state.sections.dataInizio, "Messages.ErrorDataEpidemia", "Messages.ErrorDataEpidemiaOdierna")) {
            return (this.aggiungiToaster(Utils.validateDate(this.state.sections.dataInizio, "Messages.ErrorDataEpidemia", "Messages.ErrorDataEpidemiaOdierna")))
        }

        if (this.state.sections.dataCompilazione && Utils.validateDate(this.state.sections.dataCompilazione, "Messages.ErrorDataCompilazione", "Messages.ErrorDataCompilazioneOdierna")) {
            return (this.aggiungiToaster(Utils.validateDate(this.state.sections.dataCompilazione, "Messages.ErrorDataCompilazione", "Messages.ErrorDataCompilazioneOdierna")))
        }

        let dataInizio = Utils.transformDateForBackend(this.state.sections.dataInizio);
        let dataCompilazione = Utils.transformDateForBackend(this.state.sections.dataCompilazione);
        let jsonInsert = {}
        jsonInsert["malattia"] = this.state.sections.malattia;
        jsonInsert["ulss"] = SessioneUtente.getInstance().ulss;
        jsonInsert["regione"] = this.state.sections.regione.codice;
        jsonInsert["provincia"] = this.state.sections.provincia.codice;
        jsonInsert["comune"] = this.state.sections.comune.codice;
        jsonInsert["comunita"] = this.state.sections.comunita;
        jsonInsert["comunitaAltro"] = this.state.sections.comunitaAltro ? this.state.sections.comunitaAltro : null;
        jsonInsert["numeroPersoneRischio"] = this.state.sections.numeroPersoneRischio;
        jsonInsert["indirizzo"] = this.state.sections.indirizzo;
        jsonInsert["recapito"] = this.state.sections.recapito;
        jsonInsert["dataInizioEpidemia"] = dataInizio;
        jsonInsert["dataCompilazione"] = dataCompilazione;
        jsonInsert["numeroCasi"] = this.state.sections.numeroCasi;
        jsonInsert["originePresunta"] = this.state.sections.originePresunta;
        jsonInsert["statoAgente"] = this.state.sections.agenteId;
        jsonInsert["statoVeicolo"] = this.state.sections.veicoloId;
        jsonInsert["nomeAgente"] = this.state.sections.agente;
        jsonInsert["nomeVeicolo"] = this.state.sections.veicolo;
        jsonInsert["etichetta"] = this.state.sections.etichetta;
        jsonInsert["durata"] = this.state.sections.durata;
        jsonInsert["note"] = this.state.sections.note;
        jsonInsert["migrazione"] = this.state.sections.migrazione;
        jsonInsert["altreInformazioniMigrazione"] = this.state.sections.altreInformazioniMigrazione;


        let jsonFocolaio = {}


        let associareNuovi = JSON.parse(JSON.stringify(this.state.segnalazioniDaAssociare))
        for (let i in this.state.segnalazioniDaAssociare) {
            if (Utils.checkObjectInArrayByObjectId(this.state.segnalazioniDaEliminare, "idSegnalazione", this.state.segnalazioniDaAssociare[i]) >= 0) {
                associareNuovi = Utils.arrayRemove(associareNuovi, this.state.segnalazioniDaAssociare[i]);
            }
        }
        jsonFocolaio["segnalazioniAssociate"] = associareNuovi
        jsonFocolaio["segnalazioniDaEliminare"] = Utils.objectToFieldArray(this.state.segnalazioniDaEliminare, "idSegnalazione")

        if (this.state.casoZero) {
            jsonFocolaio["idCasoZero"] = this.state.casoZero
        }
        if (this.state.casoZeroOld) {
            jsonFocolaio["idCasoZeroOld"] = this.state.casoZeroOld
        }

        if ( this.state.sections.idFocolaio ) {
            jsonInsert.ulss = this.state.sections.ulss?this.state.sections.ulss:SessioneUtente.getInstance().ulss
            this.toBase64().then((file) => {
                if (!this.state.fileDaEliminare) {
                    jsonInsert["focolaioPdfDTO"] = file;
                }
                FocolaiServices.putModificaFocolaio(Utils.removeEmptyValueFromObject(jsonInsert), this.state.sections.idFocolaio)
                    .then((data) => {
                        if (data) {
                            if (data.status === 200) {
                                this.associaFocolaioASegnalazione(this.state.sections.idFocolaio, jsonFocolaio)
                            }
                        }
                    }).catch(err => {
                    console.log("[ERR] Error while save");
                    console.log(err);
                });
            });

        } else {

            this.toBase64().then((file) => {
            jsonInsert["focolaioPdfDTO"] = file;
            FocolaiServices.postInserimentoFocolaio(Utils.removeEmptyValueFromObject(jsonInsert))
                .then((data) => {

                    if (data && data.status === 200) {
                        if (data.data && data.data.idFocolaio) {
                            this.associaFocolaioASegnalazione(data.data.idFocolaio, jsonFocolaio)
                            console.log("Chiamata al BE senza errori");
                        }
                    }
                }).catch(err => {
                console.log("[ERR] Error while save");
                console.log(err);
                });
            });
        }
    }

    disableCasoZero(row, fieldName) {
        if (this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice
            ||
            (fieldName == "casoZero" &&
                Utils.checkObjectInArrayByObjectId(this.state.segnalazioniDaEliminare, "idSegnalazione", row.idSegnalazione) >= 0))
            return true
        else return false
    }

    checkboxClick(row, value, fieldName) {

        if (fieldName === "checked") {
            this.removeSegnalazione(row)
        } else if (fieldName === "casoZero") {
            this.onSelectCasoZero(row, value)
        }
    }


    removeSegnalazione(row) {
        let daEliminare = this.state.segnalazioniDaEliminare;
        let id = row.idSegnalazione;

        if (!row.checked) {

            if (Utils.checkObjectInArrayByObjectId(daEliminare, "idSegnalazione", id) < 0) {
                daEliminare.push(row);
                if (row.casoZero == true) {
                    row.casoZero = false
                }
            }

        } else {
            if (Utils.checkObjectInArrayByObjectId(daEliminare, "idSegnalazione", id) >= 0)
                daEliminare = Utils.arrayRemove(daEliminare, id, "idSegnalazione")
        }
        this.setState({segnalazioniDaEliminare: daEliminare})
    }

    onSelectCasoZero(row, value) {
        if (value) {
            let casoZero = row["idSegnalazione"];
            this.setState({
                casoZero: casoZero
            });
        } else
            this.setState({
                casoZero: null,
                casoZeroOld: row["idSegnalazione"]
            });


    }


    home() {

        let path = "/ricercaFocolai";
        history.push({
            pathname: path
        });
    }

    associaSegnalazione() {

        this.props.history.push(
            {
                pathname: '/associaSegnalazioni',
                infoState: this.state
            });
    }

    riceviValore(field, event) {

        let newSections = this.state.sections
        let buttonDisabled = false;
        let associazioneDisabled = false;


        if (field == "comunita") {
            newSections.comunita = event.target.value;
            if (!event.target.value || (event.target.value && event.target.value !== "3")) {
                newSections.comunitaAltro = ""
            }
        } else if (field && field.target && field.target.id == "dataInizio") {
            newSections.dataInizio = field.target.value;
        } else if (field && field.target && field.target.id === "dataCompilazione") {
            newSections.dataCompilazione = field.target.value;
        } else {
            newSections[field] = event.target.value;
        }

        if (!newSections.provincia.codice) {
            newSections.comune = ""
        }

        if (field == "malattia") {

            if (event.target.value && event.target.value.codice) {
                this.setState({loading: true})
                MalattieService.getInfoMalattia(newSections.malattia).then((data) => {
                    this.setState({
                        sections: newSections,
                        listaVeicoli: data.data.veicoli,
                        loading: false,
                        disabledAssociazione: associazioneDisabled
                    })
                }).catch((reason) => {
                    console.log("errore chiamata InfoMalattia")
                    this.setState({
                        loading: false,
                        sections: newSections,
                        disabledAssociazione: associazioneDisabled
                    })
                });
            } else {
                newSections.veicolo = "";
                newSections.veicoloId = 0;
                if (this.state.listaVeicoli && this.state.listaVeicoli.length > 0)
                    this.setState({
                        sections: newSections,
                        listaVeicoli: [],
                        loading: false,
                        disabledAssociazione: associazioneDisabled
                    })
            }

        } else
            this.setState({
                sections: newSections,
                disabledAssociazione: associazioneDisabled
            });

    }

    selezionaAgenteRadio(value) {

        let newSections = this.state.sections
        newSections.agenteId = parseInt(value);

        this.setState({sections: newSections});
    }

    selezionaVeicoloRadio(value) {
        let newSections = this.state.sections
        newSections.veicoloId = parseInt(value);
        this.setState({sections: newSections});
    }


    onSubmit(e) {
        e.preventDefault()
    }

    onClickTornaAllaRicerca() {
        history.push({pathname: "/ricercaFocolai"});
    }

    setStatePadre(files) {
        if (files.fileCaricato && files.fileDaCaricare) {
            this.setState({fileCaricato: files.fileCaricato, fileDaCaricare: files.fileDaCaricare});
        } else if (files.fileCaricato) {
            this.setState({fileCaricato: files.fileCaricato});
        } else if (files.fileDaEliminare) {
            this.setState({fileCaricato: null, fileDaCaricare: null, fileDaEliminare: files.fileDaEliminare});
        } else {
            this.setState({fileDaCaricare: files.fileDaCaricare});
        }
    }

    async toBase64() {

        let base64 = this.state.file ? await Utils.toBase64(this.state.file) : null

        let file = base64 ? {
            nome: this.state.file.name??this.state.file.nome,
            pdf: base64,
            note: this.state.file.note,
            data: this.state.file.data,
        } : this.state.fileCaricato ? {
            nome: this.state.fileCaricato.name??this.state.fileCaricato.nome,
            pdf: this.state.fileCaricato.file,
            note: this.state.fileCaricato.note,
            data: this.state.fileCaricato.data,
            idFile: this.state.fileCaricato.id
        } : this.state.fileDaEliminare ? {
            nome: this.state.fileDaEliminare.name??this.state.fileDaEliminare.nome,
            pdf: this.state.fileDaEliminare.file,
            note: this.state.fileDaEliminare.note,
            data: this.state.fileDaEliminare.data,
            idFile: this.state.fileDaEliminare.id
        }:{}
        return file;
    }

    async caricaPdf(event) {
        this.setState ({loading: true});
        let dimensioneMassimaFile = parseInt(globals["dimesione-massima-file"])
        let file = event.target.files[0]
        if (file !== undefined && file.type !== undefined) {
            if (file.type !== "application/pdf") {
                this.setState ({loading: false});
                this.aggiungiToaster(["Messages.MSG_ERROR_CARICAMENTOFILE"], null, toasterConfig.types.critical);
            } else if (file.size > dimensioneMassimaFile) {
                this.setState ({loading: false});
                this.aggiungiToaster(["Messages.MSG_ERROR_LIMIT_DIMENSIONEFILE"], null, toasterConfig.types.critical);
            } else {
                file.data = format(new Date(), 'dd/MM/yyyy');
                file.stato = "inserimento";
                file.isNewFile = true;
                file.note = "";
                file.checked = true;
                let pdf = await Utils.toBase64(file).then();
                file.pdf = pdf;
                this.setState({file: file, loading: false, fileDaCaricare: file, fileDaEliminare: null});
            }
        }
        else {
            this.setState ({loading: false});
        }
    }

    render() {

        const {t} = this.props;

        let intestazioneFocolaioMigrato = ""

        if (this.state.sections.dataMigrazione) {
            intestazioneFocolaioMigrato = "Il focolaio in esame è stato importato dal vecchio sistema di segnalazione (SimiWeb) in data " +
                this.state.sections.dataMigrazione + ". Si invita a valorizzare i campi obbligatori, se non valorizzati in precedenza"
        }

        const firstSection = (
            <div>
                <div style={{marginTop: "-1rem"}}>
                    {this.state.sections.migrazione ? <h6>{intestazioneFocolaioMigrato}</h6> : null}
                    <h6>{t("GestioneFocolai.informazione.info_focolaio")}</h6>
                    <hr className={styles.hr}></hr>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("GestioneFocolai.informazione.malattia")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <SelectAutocomplete
                                    id={"malattia"}
                                    field={"malattia"}
                                    newSelect={true}
                                    onChange={this.riceviValore}
                                    value={this.state.sections.malattia}
                                    functionMap={Utils.mapToArray(this.state.malattie).map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                                    })}
                                    disabled={SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice)}
                                    visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                >
                                </SelectAutocomplete>
                                <p className={styles.testo}>{t("GestioneFocolai.informazione.dataCompilazione")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Calendar id={"dataCompilazione"} onChange={this.riceviValore}
                                          field={"dataCompilazione"}
                                          value={this.state.sections.dataCompilazione}
                                          disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ? true : !this.state.sections.migrazione}
                                          errorMessage={t("GestioneFocolai.informazione.data_non_valida")}
                                          error={(this.state.sections.dataCompilazione === "" ||
                                              this.state.sections.dataCompilazione === null) ? false :
                                              Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections.dataCompilazione), "-")}> 
                                </Calendar>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );


        const secondSection = (

            <div style={{marginTop: "5rem"}}>
                <div className="container">
                    <div className="row" style={{marginTop: "1rem"}}>
                        <div className="col-lg-4">
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("GestioneFocolai.informazione.regione")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Autocomplete
                                    id={"regione"}
                                    onChange={this.riceviValore}
                                    field={"regione"}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    value={this.state.sections.regione}
                                    suggestions={this.state.regioni}
                                    placeholder={t("GestioneFocolai.informazione.regione")}
                                    disabled={true}
                                >

                                </Autocomplete>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("GestioneFocolai.informazione.provincia")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Autocomplete id={"provincia"}
                                              onChange={this.riceviValore}
                                              field={"provincia"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              value={this.state.sections.provincia}
                                              placeholder={t("GestioneFocolai.informazione.provincia")}
                                              suggestions={
                                                  this.state.sections.regione.codice ?
                                                      Utils.filtroProvinceComuni(this.state.sections.regione.codice, this.state.province, "codiceRegione") : ""}
                                              visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                              disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                ></Autocomplete>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className={styles.fieldContainer}>
                                <p className={styles.testo}>{t("GestioneFocolai.informazione.comune")} <span
                                    className={styles.mandatoryColor}>*</span></p>
                                <Autocomplete id={"comune"}
                                              onChange={this.riceviValore}
                                              field={"comune"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              value={this.state.sections.comune}
                                              placeholder={t("GestioneFocolai.informazione.comune")}
                                              suggestions={
                                                  this.state.sections.regione.codice ? this.state.sections.provincia.codice ?
                                                      Utils.filtroProvinceComuni(this.state.sections.provincia.codice, this.state.comuni, "codiceProvincia") : "" : ""}
                                              visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                              disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ||
                                              (!this.state.sections.provincia.codice)}

                                ></Autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const thirdSection = (

            <div className="container">
                <div className="row">

                    <div className="col-lg-3">
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("GestioneFocolai.informazione.comunita")} <span
                                className={styles.mandatoryColor}>*</span></p>
                            <SelectAutocomplete
                                id={"idComunita"}
                                field={"comunita"}
                                newSelect={true}
                                onChange={this.riceviValore}
                                value={this.state.sections.comunita}
                                functionMap={Utils.mapToArray(this.state.comunita).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                                disabled={SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice)}
                                visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                            >
                            </SelectAutocomplete>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className={styles.fieldContainer}>
                            <span className={styles.testo}>{t("GestioneFocolai.informazione.personeRischio")}</span>
                            <Input type="number" id={"numeroPersoneRischio"} onChange={this.riceviValore}
                                   field={"numeroPersoneRischio"}
                                   min="0"
                                   value={this.state.sections.numeroPersoneRischio}
                                   errorMessage={"Persone a rishio non valida"}
                                   placeholder={t("GestioneFocolai.informazione.personeRischio")}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                        </div>
                    </div>


                    <div className="col-lg-3">
                        <div className={styles.fieldContainer}>
                            <span className={styles.testo}>{t("GestioneFocolai.informazione.indirizzo")}</span>
                            <Input id={"indirizzo"} onChange={this.riceviValore} field={"indirizzo"}
                                   value={this.state.sections.indirizzo}
                                   errorMessage={"Indirizzo non valido"}
                                   placeholder={t("GestioneFocolai.informazione.indirizzo")}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className={styles.fieldContainer}>
                            <span className={styles.testo}>{t("GestioneFocolai.informazione.recapito")}</span>
                            <Input id={"recapito"} onChange={this.riceviValore} field={"recapito"}
                                   value={this.state.sections.recapito}
                                   errorMessage={"Persone a rishio non valida"}
                                   placeholder={t("GestioneFocolai.informazione.recapito")}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                        </div>
                    </div>
                </div>
            </div>


        );

        const tenSection = (

            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className={styles.fieldContainer}>
                            <span
                                className={styles.testo}>{t("GestioneFocolai.informazione.comunitaAltro")}{this.state.sections.comunita === "3" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}</span>
                            <Input id={"comunitaAltro"} onChange={this.riceviValore} field={"comunitaAltro"}
                                   value={this.state.sections.comunita === "3" ? this.state.sections.comunitaAltro : ""}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={!this.state.sections.comunita || (this.state.sections.comunita !== "3") || (this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice)}
                                   placeholder={t("GestioneFocolai.informazione.comunitaAltro")}
                            ></Input>
                        </div>
                    </div>
                </div>
            </div>
        );


        const fourSection = (
            <div className="container">
                <div className="row">
                    <div className="col-lg-2">
                        <p className={styles.testo}>{t("GestioneFocolai.informazione.numeroCasi")} <span
                            className={styles.mandatoryColor}>*</span></p>
                        <Input type={"number"} min="0" id={"numeroCasi"} onChange={this.riceviValore}
                               field={"numeroCasi"}
                               value={this.state.sections.numeroCasi}
                               errorMessage={"Comunità non valida"}
                               placeholder={t("GestioneFocolai.informazione.numeroCasi")}
                               visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                               disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                    </div>

                    <div className="col-lg-4">
                        <p className={styles.testo}>{t("GestioneFocolai.informazione.luogoOrigine")} </p>
                        <Input id={"originePresunta"} onChange={this.riceviValore} field={"originePresunta"}
                               value={this.state.sections.originePresunta}
                               errorMessage={"Luogo d'origine non valido"}
                               placeholder={t("GestioneFocolai.informazione.luogoOrigine")}
                               visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                               disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                    </div>
                </div>
            </div>
        );

        const sixSection = (
            <div className="container">
                <div className="row">

                    <div className="col-lg-4  col-md-12">
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("GestioneFocolai.informazione.agente")} </p>
                            <Input id={"agente"} onChange={this.riceviValore} field={"agente"}
                                   value={this.state.sections.agente}
                                   placeholder={t("GestioneFocolai.informazione.agente")}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-12" style={{maxWidth: "30%"}}>


                        <RadioButton id={"agenteIdentificato"}
                                     name={"gruppo1"} label={"Identificato"}
                                     value={"1"} onClick={this.selezionaAgenteRadio}
                                     checked={this.state.sections.agenteId === 1}
                                     disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                        ></RadioButton>

                        <RadioButton id={"agenteSospetto"}
                                     name={"gruppo1"} label={"Sospetto"}
                                     value={"2"} onClick={this.selezionaAgenteRadio}
                                     checked={this.state.sections.agenteId === 2}
                                     disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                        ></RadioButton>

                    </div>


                    <div className="col-lg-4  col-md-12">
                        <p className={styles.testo}>{t("GestioneFocolai.informazione.veicolo")} </p>
                        <Input id={"veicolo"} onChange={this.riceviValore} field={"veicolo"}
                               value={this.state.sections.veicolo}
                               placeholder={t("GestioneFocolai.informazione.veicolo")}
                               visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                               disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                    </div>

                    <div className="col-lg-2 col-md-12" style={{maxWidth: "30%"}}>

                        <RadioButton id={"veicoloIdentificato"}
                                     name={"gruppo2"} label={"Identificato"}
                                     value={"1"} onClick={this.selezionaVeicoloRadio}
                                     checked={this.state.sections.veicoloId === 1}
                                     disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                        ></RadioButton>

                        <RadioButton id={"veicoloSospetto"}
                                     name={"gruppo2"} label={"Sospetto"}
                                     value={"2"} onClick={this.selezionaVeicoloRadio}
                                     checked={this.state.sections.veicoloId === 2}
                                     disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                        ></RadioButton>

                    </div>
                </div>
            </div>
        )

        const sevenSection = (
            <div
                className={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ? ["container", "visualizzazione"].join(" ") : "container"}>
                <div className="row">
                    <div className="col-lg-4">
                        <p className={styles.testo}>{t("GestioneFocolai.informazione.dataInizio")} </p>
                        <Calendar id={"dataInizio"} onChange={this.riceviValore} field={"dataInizio"}
                                  disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                  value={this.state.sections.dataInizio}
                                  errorMessage={t("GestioneFocolai.informazione.data_non_valida")}
                                  error={(this.state.sections.dataInizio == "" || this.state.sections.dataInizio == null) ? false :
                                      Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections.dataInizio), "-")
                                  }>
                        </Calendar>
                    </div>


                    <div className="col-lg-2">
                        <span className={styles.testo}>{t("GestioneFocolai.informazione.durata")}</span>
                        <Input type={"number"} min="0" id={"idDurata"} onChange={this.riceviValore} field={"durata"}
                               classes="elemento-visualizzazione"
                               value={this.state.sections.durata} errorMessage={"Durata non valida"}
                               placeholder={t("GestioneFocolai.informazione.durata")}
                               disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                    </div>
                </div>
            </div>
        );


        const eightSection = (
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("GestioneFocolai.informazione.etichetta")} <span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"etichetta"} onChange={this.riceviValore} field={"etichetta"}
                                   value={this.state.sections.etichetta}
                                   errorMessage={"Etichetta non valida"}
                                   placeholder={t("GestioneFocolai.informazione.etichetta")}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}></Input>
                        </div>
                    </div>
                </div>
            </div>
        );

        const nineSection = (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}>{t("GestioneFocolai.informazione.note")} </p>
                            <Input placeholder={t("GestioneFocolai.informazione.inserisciNote")} type={"textarea"}
                                   id={"note"}
                                   value={this.state.sections.note}
                                   field={"note"}
                                   onChange={this.riceviValore}
                                   onValidate={this.state.sections.note ? (this.state.sections.note.startsWith(" ") ? 1 : 2) : 2}
                                   errorMessage={"Campo note non valido"}
                                   visualizzazione={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                   disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

        const altreInformazioniFocolaioMigrato = (
            <div className="container">
                <div style={{marginTop: "2rem"}}>
                    <div>
                        <h6>{t("Esito.migrazione")}</h6>
                        <hr className={styles.hr}></hr>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <Input
                                style={{height: "400px"}}
                                type={"textarea"}
                                id={"noteMigrazione"}
                                value={this.state.sections.migrazione ? this.state.sections.altreInformazioniMigrazione.replaceAll(",", ",\n\t")
                                    .replace("{", "{\n\t").replace("}", "\n}") : ""}
                            >
                            </Input>
                        </div>
                    </div>
                </div>
            </div>
        );

        const tableAllegato = (
            <div className="container">
                {(!this.state.fileCaricato && !this.state.fileDaCaricare) ?
                    <div className="row justify-content-center" style={{marginTop: "3rem"}}>
                        <label className="btnWhite" style={{height: "3rem", alignItems: "center", cursor: "pointer"}}>
                            <input type="file"
                                   onChange={this.caricaPdf}
                                   style={{display: "none"}}
                                   accept="application/pdf"
                            />
                            <p style={{height: "3rem", marginTop: "1rem"}}>
                                {t("InfoCliniche.caricaAllegato")}</p>
                        </label>
                    </div> :
                    <TableAllegatoFocolaio
                        file={this.state.fileDaCaricare?.isNewFile ? this.state.fileDaCaricare : this.state.fileCaricato?.stato !== "eliminazione" ? this.state.fileCaricato : {}}
                        isNewFile={!!this.state.fileCaricato?.id}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        showSpinner={this.showSpinner}
                        setStatePadre={this.setStatePadre}
                    />
                }
            </div>
        );

        const form = (
            <div
                className={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ? [styles.contenitoreRicerca, "visualizzazione"].join(" ") : "container"}>
                {firstSection}
                {secondSection}
                {thirdSection}
                {tenSection}
                {fourSection}
                {sixSection}
                {sevenSection}
                {eightSection}
                {nineSection}
                {tableAllegato}
            </div>
        );

        const tableDiv = (

            <div className={["container", styles.contenitoreTabella].join(" ")}>
                <div className="row justify-content-end">
                    <div style={{marginTop: "0.5rem"}}>
                        <Button text={t("Buttons.associa")}
                                disabled={this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice}
                                onClick={this.controlloDatiToaster}
                                className={"btnWhite"}
                                style={{height: "2rem"}}
                        >
                        </Button>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <Table cols={this.cols}
                               rows={this.state.segnalazioniAssociate}
                               title={t("GestioneFocolai.associaSegnalazioni.segnalazioni")}
                               empty={this.state.rows && this.state.rows.length == 0}
                               emptyMsg={t("GestioneFocolai.associaSegnalazioni.error")}
                               lengthEditable={true}
                               onSelectCheckbox={this.checkboxClick}
                               disableCheckbox={this.disableCasoZero}
                               pagination={true}
                               totalElements={this.state.totalElements}
                               tableLenght={this.state.size}
                               totalPages={this.state.totalPages}
                               page={this.state.page}
                               changePage={this.changePageTable}
                               changePagination={this.changePaginationTable}
                        />
                    </div>

                </div>
            </div>
        );

        const campoObbligatorio = (
            <div className={["container", styles.mandatoryColor].join(" ")}
                 style={{paddingTop: "1rem"}}>{t("GestioneFocolai.informazione.campoObbligatorio")}</div>
        );

        const buttonDiv = (
            <div className={"row"} style={{marginTop: "2rem"}}>
                {this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ?
                    <div className="col-lg-4"/> : <div className="col-lg-1"/>
                }

                <div className="col-lg-4 col-md-12">
                    {
                        this.state.disabledAssociazione || this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ?
                            <div className="col-lg-12 text-center">
                                <Button className="btnWhite " id={"esci"}
                                        text={t("Buttons.exit_solo")}
                                        onClick={this.home}
                                        style={{height: "3rem", marginTop: "1rem", marginLeft: "1rem"}}
                                />
                            </div>
                            :
                            <Modale classes="btnWhite " id={"esci"} typeModal="modalConsenso"
                                    modalText={t("Messages.ERR_01_07_0B_0A")}
                                    text={t("Buttons.exit")}
                                    title={t("Buttons.exit")}
                                    style={{height: "3rem", marginTop: "1rem"}}
                                    confirmFun={this.home}
                            />
                    }
                </div>

                <div className="col-lg-2"/>
                {this.state.sections.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice ?
                    null
                    : <div className="col-lg-4 col-md-12">
                        <Modale classes="btnBlu " id={"salva"} typeModal="modalConsenso"
                                modalText={this.state.segnalazioniDaEliminare && this.state.segnalazioniDaEliminare.length > 0 ?
                                    t("Messages.CONFERMA_ELIMINA_SEGN_FOCOLAIO") :  
                                    (this.state.casoZero && this.state.casoZero.length>0)  ? t("Messages.CONFERMA_FOCOLAIO"):
                                    ((!this.state.casoZeroOld || this.state.casoZeroOld.length==0) &&
                                    ( this.state.casoZeroIniziale && this.state.casoZeroIniziale.length>0))?t("Messages.CONFERMA_FOCOLAIO"):t("Messages.CONFERMA_FOCOLAIO_SENZA_CASO_ZERO")}
                                text={t("Buttons.save")}
                                title={t("Buttons.save")}
                                style={{height: "3rem", marginTop: "1rem"}}
                                confirmFun={this.controlloDatiToaster}  
                              
                        />
                    </div>}
            </div>
        );

        return (
            <div style={{paddingTop: "2rem"}}>
                {ToasterSingleton.instance().renderToaster()}
                {this.state.loading ? (<div><Spinner/></div>) : (<div/>)}
                {this.state.sections && this.state.sections.idFocolaio?<div>
                    <div>
                        <Button id={"tornaAllaRicercaFocolai"} text={t("Buttons.torna_alla_ricerca")}
                                className={["btnWhite", "col-lg-12"].join(" ")}
                                style={{height: "2rem", fontSize: "15px", float: "right", width: "15vw"}}
                                onClick={() => {
                                    this.onClickTornaAllaRicerca()
                                }}
                        />
                    </div>
                    <br/>
                </div>:<></>}
                <form onSubmit={this.onSubmit}>
                    {form}
                    {this.state.sections.migrazione ? altreInformazioniFocolaioMigrato : null}
                    {tableDiv}
                    {campoObbligatorio}
                    {buttonDiv}
                </form>

            </div>

        )
    }
}

export default withTranslation('common')(InformazioniFocolaio);
